import { createLink } from '@tanstack/react-router';

import { ListBoxItem, type ListBoxItemProps } from '@/libs/serenity-ui';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RouterListBoxItemLink = createLink(({ className, ...props }: ListBoxItemProps<unknown> & { className?: string }) => <ListBoxItem {...props} />);
